import { Box } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './cardStyle.js'

export default function Card(props) {
  const {
    className,
    children,
    plain,
    profile,
    blog,
    raised,
    background,
    pricing,
    color,
    product,
    testimonial,
    chart,
    login,
    sx = {},
    ...rest
  } = props
  return (
    <Box
      component={'div'}
      sx={[
        sx,
        styles.card,
        plain && styles.cardPlain,
        (profile || testimonial) && styles.cardProfile,
        blog && styles.cardBlog,
        raised && styles.cardRaised,
        background && styles.cardBackground,
        (pricing && color !== undefined) ||
          (pricing && background !== undefined && styles.cardPricingColor),
        color && styles[color],
        pricing && styles.cardPricing,
        product && styles.cardProduct,
        chart && styles.cardChart,
        login && styles.cardLogin,
      ]}
      className={className}
      {...rest}
    >
      {children}
    </Box>
  )
}

Card.propTypes = {
  className: PropTypes.string,
  plain: PropTypes.bool,
  profile: PropTypes.bool,
  blog: PropTypes.bool,
  raised: PropTypes.bool,
  background: PropTypes.bool,
  pricing: PropTypes.bool,
  testimonial: PropTypes.bool,
  color: PropTypes.oneOf([
    'primary',
    'info',
    'success',
    'warning',
    'danger',
    'rose',
  ]),
  product: PropTypes.bool,
  chart: PropTypes.bool,
  login: PropTypes.bool,
  children: PropTypes.node,
  sx: PropTypes.object || PropTypes.string,
}
